import {
  ChatDocumentLanguage,
  ChatWritingStyle,
} from '@distribute/shared/types';

export const CUSTOM_TAG = {
  COMMENT: 'COMMENT',
  TAB: 'TAB',
  NOTMODIFIED: 'NOTMODIFIED',
};

export const CHAT_LANGUAGE_MAP: Record<ChatDocumentLanguage, string> = {
  [ChatDocumentLanguage.EN]: 'Default (English)',
  [ChatDocumentLanguage.DA]: 'Dansk',
  [ChatDocumentLanguage.DE]: 'Deutsch',
  [ChatDocumentLanguage.ES]: 'Español',
  [ChatDocumentLanguage.FR]: 'Français',
  [ChatDocumentLanguage.IT]: 'Italiano',
  [ChatDocumentLanguage.JA]: '日本語',
  [ChatDocumentLanguage.KO]: '한국어',
  [ChatDocumentLanguage.NL]: 'Nederlands',
  [ChatDocumentLanguage.PL]: 'Polski',
  [ChatDocumentLanguage.PT]: 'Português',
  [ChatDocumentLanguage.SL]: 'Slovenčina',
  [ChatDocumentLanguage.SV]: 'Svenska',
  [ChatDocumentLanguage.TR]: 'Türkçe',
  [ChatDocumentLanguage.ZH]: '中文',
};

export const CHAT_WRITING_STYLE_MAP: Record<ChatWritingStyle, string> = {
  [ChatWritingStyle.DEFAULT]: 'Default',
  [ChatWritingStyle.ARGUMENTATIVE]: 'Argumentative',
  [ChatWritingStyle.CONVERSATIONAL]: 'Conversational',
  [ChatWritingStyle.CREATIVE]: 'Creative',
  [ChatWritingStyle.INFORMATIVE]: 'Informative',
  [ChatWritingStyle.INSTRUCTIVE]: 'Instructive',
  [ChatWritingStyle.TECHNICAL]: 'Technical',
};

export const CHAT_SETTINGS_DEFAULT = {
  temperature: 0.8,
  writingStyle: ChatWritingStyle.DEFAULT,
  documentLanguage: ChatDocumentLanguage.EN,
};
